import { logger } from "../default-logger";


/**
 * Syncs the newly selected params with localstorage so we can load selectors with the previously selected params when navigating to a page
 * Localstorage objects follow the naming convention `lastUsedParams-${appID}`
 * Adds params to lastUsed if not present, updates values, and saves to localstorage
 * @param {*} objName the name of the object in localstorage to sync
 * Current naming conventions:
 * - Dynamic views: lastUsedParams-appID
 * - Alerts: lastUsedAlert-projID
 * - Historian: lastUsedHistorian-projID
 * @param {*} newSelectedParams 
 * @returns syncedParams, the newly synced selected params
 */
export function syncLastUsedParams(objName, newSelectedParams, deletedParams = []) {
  if (!objName) return {};
  if (typeof objName !== 'string') return {};
  logger.debug('sync start', objName, newSelectedParams, deletedParams);
  
  let lastUsedParams = JSON.parse(localStorage.getItem(objName)) ?? {};
  let syncedParams = deepMerge(lastUsedParams, newSelectedParams, deletedParams);
  logger.debug('deep merge final', syncedParams, lastUsedParams, newSelectedParams, deletedParams);

  localStorage.setItem(objName, JSON.stringify(syncedParams));
  return syncedParams;
}

/**
 * Merges nested objects
 * @param {*} target 
 * @param {*} source 
 * @returns output, the merged object
 */
function deepMerge(target, source, deleted=[]) {
  logger.debug('deep merge start', target, source, deleted);
  const output = { ...target }

  for (const key in source) {
    logger.debug('deep merge key', key, source[key], target[key], deleted.includes(key), deleted)
    if (!Array.isArray(source[key]) && typeof source[key] === 'object') { // recurse if there's child params 
      logger.debug('deep merge found nested obj', key, source[key], target[key], target);
      output[key] = target.hasOwnProperty(key) && typeof target[key] === 'object' ? deepMerge(target[key], source[key], deleted) : deepMerge({}, source[key], deleted);
    } else {
      output[key] = source[key];
    }
  }

  for (const key of deleted) {
    if (output[key]) delete output[key];
  }

  return output;
}